import React from "react";
import { useParams } from "react-router-dom";
import { Category } from "../Types/category.types";
import { initialCategory } from "../initialState";
import { useGetCategoriesQuery, useGetCategoryByIdQuery, useUpdateCategoryMutation } from "../Service/categoriesApi";
import { CategoriesRoutes } from "../../../Router/path";
import { CircularProgress, Typography } from "@mui/material";
import { categoryFields } from "../fields";
import EntityFormLayout from "../../Shared/Components/EntityFormLayout/EntityFormLayout";
import AccordionCard from "../../Shared/Components/AccordionCard/AccordionCard";
import { useDeleteCategoryImageMutation, useGetCategoryWithImagesQuery, useUploadCategoryImagesMutation } from "../Service/extendedCategoriesApi";
import UploadedImagesGallery from "../../Shared/Components/UploadedImagesGallery/UploadedImagesGallery";
import UploadImagesForm from "../../Shared/Components/UploadImagesForm/UploadImagesForm";

import PublicIcon from '@mui/icons-material/Public';
import InfoIcon from '@mui/icons-material/Info';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import ImageIcon from '@mui/icons-material/Image';
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';

const EditCategory = () => {

    const categoryId = useParams<{ categoryId: string }>().categoryId;
    const parsedCategoryId = categoryId ? parseInt(categoryId) : 0;

    const {
        data: categoryDataById,
        isLoading: categoryDataByIdLoading,
        error: categoryDataByIdError,
    } = useGetCategoryByIdQuery(parsedCategoryId, { skip: !categoryId });

    const {
        data: allCategories,
        isLoading: isAllCategoriesLoading,
    } = useGetCategoriesQuery();
    const {
        data: categoryWithImagesData,
        isLoading: isImagesLoading,
        isError: isImagesError,
    } = useGetCategoryWithImagesQuery(parsedCategoryId)
    const [updateCategory, updateStatus] = useUpdateCategoryMutation();
    const [uploadCategoryImages, uploadState] = useUploadCategoryImagesMutation()



    const entityForm = useEntityForm<Category>({
        initialData: categoryDataById ?? initialCategory,
        fields: categoryFields
            .map((field) => {
                if (field.type === "autocomplete" && allCategories) {
                    return {
                        ...field,
                        name: field.name as keyof Category,
                        options: allCategories.map((cat) => ({
                            label: cat.name,
                            value: cat.id,
                        })),
                        loading: isAllCategoriesLoading,

                    };
                }
                return {
                    ...field,
                    name: field.name as keyof Category,

                }
            }),
        submitFn: (data) => updateCategory({ id: parsedCategoryId, data }).unwrap(),
        redirectUrl: CategoriesRoutes.root,
        title: 'Edytuj kategorię',
        icon: <PublicIcon />,
        backUrl: CategoriesRoutes.root,
        groupOrder: ['Podstawowe', 'SEO', 'Konfiguracja'],
        groupIcons: {
            Podstawowe: <InfoIcon />,
            SEO: <SearchIcon />,
            Konfiguracja: <SettingsIcon />
        },
        mutationStatus: updateStatus,
    });


    // useEffect(() => {
    //     if (categoryDataById) {
    //         setFormData({ ...categoryDataById, id: parseInt(categoryId!) });
    //     }
    // }, [categoryDataById, categoryId]);


    if (categoryDataByIdLoading) {
        return (
            <Typography align="center" sx={{ mt: 4 }}>
                <CircularProgress />
            </Typography>
        );
    }

    if (categoryDataByIdError) {
        return (
            <Typography color="error" align="center" sx={{ mt: 4 }}>
                Nie udało się załadować danych kategorii.
            </Typography>
        );
    }


    return (
      <EntityFormLayout {...entityForm}>
        <AccordionCard title="Wgrane zdjęcia" icon={<ImageIcon />}>
          {categoryWithImagesData?.images?.length ? (
            <>
              <UploadedImagesGallery
                images={categoryWithImagesData.images}
                isLoading={isImagesLoading}
                isError={isImagesError}
                useDeleteMutation={useDeleteCategoryImageMutation}
                mutationParams={(imageId) => ({ imageId, categoryId: parsedCategoryId })}
              />
              <UploadImagesForm
                useUploadMutation={() => [uploadCategoryImages, uploadState]}
                mutationParams={(files) => ({ categoryId: parsedCategoryId, files })}
              />
            </>
          ) : (
            <Typography color="text.secondary" component="div">
              Nie wgrano jeszcze żadnych zdjęć.
              <UploadImagesForm
                useUploadMutation={() => [uploadCategoryImages, uploadState]}
                mutationParams={(files) => ({ categoryId: parsedCategoryId, files })}
              />
            </Typography>
          )}
        </AccordionCard>
      </EntityFormLayout>
    );
}
export default EditCategory;
